const labels = {
    en: {
        title: "Knowledge Transfer",
        // subtitle_1: 'Diagnosis:',
        parag_1: 'This patient’s blood pressure is above target. Diabetes Canada guidelines recommend that people with diabetes should be treated to achieve a blood pressure < 130/80 mmHg.',
        reference: [
            'Diabetes Canada Clinical Guidelines Expert Committee, Tobe SW, Gilbert RE, et al. Treatment of hypertension. Can J Diabetes 2018;42 Suppl 1:S186-S189. doi:10.1016/j.jcjd.2017.10.011'
        ]
    },
    fr: {
        title: "Le transfert du savoir",        
        // subtitle_1: 'Diagnostic:',
        parag_1: "La tension artérielle de ce patient est au-dessus de la cible. Les lignes directrices de Diabète Canada recommandent de traiter les personnes atteintes de diabète afin qu’elles atteignent une tension artérielle < 130/80 mm Hg.",
        reference: [
            "Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Tobe SW, Gilbert RE, et al. Traitement de l’hypertension. Can J Diabetes 42 (2018) S186-S189. doi : 10.1016/j.jcjd.2017.10.011."
        ]
    }
};

export default labels